import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=1af35bce&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af35bce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1af35bce')) {
      api.createRecord('1af35bce', component.options)
    } else {
      api.reload('1af35bce', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=1af35bce&scoped=true&", function () {
      api.rerender('1af35bce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BDyNjYizvGHT/JS/comp/SearchFilterTokens.vue"
export default component.exports